import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const AdminPage = () => {
  const { t } = useTranslation();
  
  return (
    <Layout>
      <Text>{t('admin.preparing')}</Text>
    </Layout>
  );
};

const Text = styled.p`
  ${({ theme }) => theme.typography.BOLD_72};
`;

const Layout = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #f7f8fa;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default AdminPage;
